import { env } from "@/config";
import { getSelectedSessionId } from "@/sdk";
import { getSharedApiClient } from "@/shared-utils";

export const getSalesApiClient = () => {
    return getSharedApiClient(getSelectedSessionId()).extend(() => ({
        prefix: `${env.backendUrls.apiBaseUrl}/api/sales`,
    }));
};

export const getGamificationApiClient = () => {
    return getSharedApiClient(getSelectedSessionId()).extend(() => ({
        prefix: `${env.backendUrls.apiBaseUrl}/api/gamification`,
        hooks: {
            beforeRequest: [
                ({ request }) => {
                    request.headers.set("x-ewp-correlation-id", getSelectedSessionId());
                },
            ],
        },
        retry: {
            limit: 0,
        },
    }));
};
